export const invoicePostingState = {
  NotPosted: 1,
  Posting: 2,
  Posted: 3,
  Failed: 4,
  ChangedAfterPosting: 5
}

export const INVOICE_POSTING_STATE_OPTIONS = [
  { id: invoicePostingState.NotPosted, name: 'Not posted' },
  { id: invoicePostingState.Posting, name: 'Posting' },
  { id: invoicePostingState.Posted, name: 'Posted' },
  { id: invoicePostingState.Failed, name: 'Failed' },
  { id: invoicePostingState.ChangedAfterPosting, name: 'Changed after posting' }
]

export const invoicePostingOutcome = {
  Posted: 'Posted'
}

export const invoiceKind = {
  TimeSheet: 1,
  ExpenseSheet: 2
}

const invoicePostingStateColors = {
  [invoicePostingState.NotPosted]: { color: 'grey', dark: true },
  [invoicePostingState.Posting]: { color: 'blue', dark: true },
  [invoicePostingState.Posted]: { color: 'green', dark: true },
  [invoicePostingState.Failed]: { color: 'red', dark: true },
  [invoicePostingState.ChangedAfterPosting]: { color: 'orange', dark: true }
}

export const invoicePostingStateAttrs = (stateId) => invoicePostingStateColors[stateId] || { color: 'grey lighten-2', dark: false }
